module.exports = __webpack_public_path__ + "img/ingamedrill.db0b9a39.png";